<template>
	<div v-reveal:fade-in class="mt-400-lg mt-200 text-align-center-smo">
		<p class="label-sm text-transform-uppercase text-color-content-tertiary"
			>Trusted by more than 2 million people</p
		>
		<HorizontalScroll v-if="appStore.isMobile" class="mt-100 justify-content-space-between">
			<template #scroll-items>
				<div
					v-for="rating in ratingsDetails"
					:key="rating.svgName"
					class="display-flex flex-direction-column align-items-center"
				>
					<div class="text-color-gray-40 text-align-center">
						<BaseSvgIcon
							:name="rating.svgName"
							:height="rating.mobileHeight"
							:width="rating.mobileWidth"
							class="text-color-gray-40"
						/>
					</div>
					<RatingsStars class="mt-50" :rating="rating.rating" stars-color="#D5BD8D" size="18" />
				</div>
			</template>
		</HorizontalScroll>
		<div v-else class="display-flex justify-content-space-between mt-150">
			<div v-for="rating in ratingsDetails" :key="rating.svgName">
				<div class="text-color-gray-40 text-align-center">
					<BaseSvgIcon
						:name="rating.svgName"
						:height="rating.height"
						:width="rating.width"
						class="text-color-gray-40"
					/>
				</div>
				<RatingsStars class="mt-50" :rating="rating.rating" stars-color="#D5BD8D" size="16" />
			</div>
		</div>

		<p class="text-color-content-tertiary body-xs mt-200-md mt-100-smo"
			><BaseButton
				classes="link text-color-current-color text-decoration-underline"
				@click="scrollToAnchor('socialStatsDisclaimers')"
				>Learn more</BaseButton
			>
			about rating details.</p
		>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import HorizontalScroll from '@components/wizard/horizontal-scroll.vue';
import RatingsStars from '@components/marketing-site/ratings-stars.vue';
import { scrollToAnchor } from '@utils/scroll-to';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const ratingsDetails = computed(
	(): Array<{
		svgName: string;
		height: number;
		width: number;
		mobileHeight: number;
		mobileWidth: number;
		rating: string;
	}> => {
		const detailsList = [
			{
				svgName: 'logo-nerdwallet',
				height: 18,
				width: 99,
				mobileHeight: 24,
				mobileWidth: 154,
				rating: '5'
			},
			{ svgName: 'logo-apple', height: 20, width: 16.74, mobileHeight: 24, mobileWidth: 20, rating: '4.8' },
			{ svgName: 'logo-google', height: 21, width: 63, mobileHeight: 24, mobileWidth: 74, rating: '4.7' }
		];
		if (!appStore.isTablet) {
			detailsList.push({
				svgName: 'logo-investopedia',
				height: 16,
				width: 101.777,
				mobileHeight: 21,
				mobileWidth: 152.67,
				rating: '4.7'
			});
		}
		return detailsList;
	}
);
</script>
